// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x3PQRl7sIIQXsdbMxbSs{padding:11px 20px 24px}.J5HRK8P5ZqcOeXmzI19R{padding-bottom:24px;padding-right:8px}.vvuIMbPdfD4Lt7fl8sXk{align-items:center;gap:12px;display:flex}.ZN9epizc5MQULUUTgRbM{align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `x3PQRl7sIIQXsdbMxbSs`,
	"settings": `J5HRK8P5ZqcOeXmzI19R`,
	"recordControls": `vvuIMbPdfD4Lt7fl8sXk`,
	"controlsLeft": `ZN9epizc5MQULUUTgRbM`
};
export default ___CSS_LOADER_EXPORT___;
